import { render } from "./DishList.vue?vue&type=template&id=3e5d2fb4&scoped=true"
import script from "./DishList.vue?vue&type=script&lang=js"
export * from "./DishList.vue?vue&type=script&lang=js"

import "./DishList.vue?vue&type=style&index=0&id=3e5d2fb4&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5d2fb4"]])

export default __exports__